import { memo } from "react";
import { Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { PrimaryButton } from "@/components/common/PrimaryButton";

interface ManageDocumentsFooterProps {
  step: 0 | 1;
  summaryText: string;
  canRelease: boolean;
  hasRejected: boolean;
  docsOk: boolean;
  canConfirm: boolean;
  submitting: boolean;
  docsRefreshing: boolean;
  onAdvance: () => void;
  onConfirm: () => void;
}

export const ManageDocumentsFooter = memo(function ManageDocumentsFooter({
  step,
  summaryText,
  canRelease,
  hasRejected,
  docsOk,
  canConfirm,
  submitting,
  docsRefreshing,
  onAdvance,
  onConfirm,
}: ManageDocumentsFooterProps) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      sx={{
        flexShrink: 0,
        pt: 1.25,
        pb: 0.25,
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {step === 1
          ? summaryText
          : canRelease && hasRejected
            ? "Há documentos recusados — você já pode avançar para a liberação."
            : docsOk
              ? "Documentos verificados — você já pode liberar a compra."
              : "Verifique todos os documentos para avançar."}
      </Typography>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        {step === 0 ? (
          <PrimaryButton
            width="fit-content"
            height="40px"
            disabled={!canRelease || submitting || docsRefreshing}
            onClick={onAdvance}
            endIcon={<ArrowForwardIcon />}
          >
            Avançar para liberação
          </PrimaryButton>
        ) : (
          <PrimaryButton
            width="fit-content"
            height="40px"
            disabled={!canConfirm}
            onClick={onConfirm}
            startIcon={<CheckCircleOutlineIcon />}
          >
            Confirmar liberação
          </PrimaryButton>
        )}
      </Stack>
    </Stack>
  );
});
